import LoadDeviceTypes from "./LoadDeviceTypes.js";
import { install } from "./PluginSetup.js";
export default {
  LoadDeviceTypes,
  install
};